export const standard = `cubic-bezier(0.4, 0.0, 0.2, 1)`;